export default function UseCaseManagerNavigation() {
  return <div>Use case manager</div>;
}
